// extracted by mini-css-extract-plugin
module.exports = {"blockClick":"SendersSmsList_blockClick_30Jsf"};